var _defs, _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e79e53df-18d2-485b-8e84-4de6b41a2f4e",
    "data-name": "\\u5716\\u5C64 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e9a9d974-5b2b-42fc-a2ee-3f9f2aec61d8,.f38b3374-8429-4057-8b57-fdc8ae677bf8{fill:none;}.adb05e6d-0642-4cf2-b0b1-3df5ef0d961b,.f38b3374-8429-4057-8b57-fdc8ae677bf8{stroke:#8e8e8e;}.adb05e6d-0642-4cf2-b0b1-3df5ef0d961b,.e9a9d974-5b2b-42fc-a2ee-3f9f2aec61d8,.f38b3374-8429-4057-8b57-fdc8ae677bf8{stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.adb05e6d-0642-4cf2-b0b1-3df5ef0d961b,.e2a6e064-2771-4ca3-a796-e4f35aaa135f{fill:#3ba595;}.a14e98d6-de70-4fd2-b46b-3d83164e1049{fill:#fff;}.e9a9d974-5b2b-42fc-a2ee-3f9f2aec61d8{stroke:#645346;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "css") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "f38b3374-8429-4057-8b57-fdc8ae677bf8",
    d: "M22.3,78.2a4.1,4.1,0,0,0,4.1,4.2H67.3a4.2,4.2,0,0,0,4.2-4.2V21.8a4.2,4.2,0,0,0-4.2-4.2H36.7L22.3,32.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "adb05e6d-0642-4cf2-b0b1-3df5ef0d961b",
    d: "M22.3,32.1H32.6A4.1,4.1,0,0,0,36.7,28V17.6Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "e2a6e064-2771-4ca3-a796-e4f35aaa135f",
    x: 32.8,
    y: 59.5,
    width: 44.9,
    height: 14.99,
    rx: 2.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a14e98d6-de70-4fd2-b46b-3d83164e1049",
    d: "M51.2,72a6.5,6.5,0,0,1-2.6.5,4.7,4.7,0,0,1-5-5.1,5,5,0,0,1,5.3-5.3,5.7,5.7,0,0,1,2.4.4l-.4,1.1a4,4,0,0,0-2-.4c-2.4,0-3.9,1.5-3.9,4.1s1.4,4.1,3.8,4.1A7.2,7.2,0,0,0,51,71Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a14e98d6-de70-4fd2-b46b-3d83164e1049",
    d: "M52.7,70.7a4.2,4.2,0,0,0,2.3.7c1.4,0,2.1-.7,2.1-1.7s-.5-1.5-1.9-2-2.6-1.5-2.6-2.9,1.3-2.7,3.2-2.7a4.4,4.4,0,0,1,2.3.5l-.4,1a3.6,3.6,0,0,0-1.9-.5,1.7,1.7,0,0,0-1.9,1.6c0,.9.6,1.4,2,1.9s2.6,1.5,2.6,3-1.2,2.9-3.6,2.9a4.6,4.6,0,0,1-2.5-.7Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a14e98d6-de70-4fd2-b46b-3d83164e1049",
    d: "M60.1,70.7a4.2,4.2,0,0,0,2.3.7c1.4,0,2.1-.7,2.1-1.7s-.5-1.5-1.9-2S60,66.2,60,64.8s1.3-2.7,3.2-2.7a4.4,4.4,0,0,1,2.3.5l-.4,1a3.6,3.6,0,0,0-1.9-.5,1.7,1.7,0,0,0-1.9,1.6c0,.9.6,1.4,2,1.9s2.6,1.5,2.6,3-1.2,2.9-3.6,2.9a4.6,4.6,0,0,1-2.5-.7Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "e9a9d974-5b2b-42fc-a2ee-3f9f2aec61d8",
    d: "M41.8,34.9a2.7,2.7,0,0,0-2.1,2.8c0,5-.5,5.7-1.8,6.1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "e9a9d974-5b2b-42fc-a2ee-3f9f2aec61d8",
    d: "M41.8,52.6a2.6,2.6,0,0,1-2.1-2.8c0-5-.5-5.6-1.8-6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "e9a9d974-5b2b-42fc-a2ee-3f9f2aec61d8",
    d: "M52,52.6a2.6,2.6,0,0,0,2-2.8c0-5,.5-5.6,1.9-6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "e9a9d974-5b2b-42fc-a2ee-3f9f2aec61d8",
    d: "M52,34.9a2.7,2.7,0,0,1,2,2.8c0,5,.5,5.7,1.9,6.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.acc7c56e1c2676bcdf4a7041c1a7ac3c.svg";
export { ForwardRef as ReactComponent };